import { Typography } from '@maia/ui';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getCustomerOptions } from '../../../../../features/customer/customer/queryOptions';
import { CustomerInformation } from '../../../../../features/shared/customer/customer-information';

export const Route = createFileRoute(
  '/_authenticated/cart/new/$customer/_layout',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { customer: guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
});

function RouteComponent() {
  const data = Route.useLoaderData();
  return (
    <div className="content-grid layout-sidebar">
      <Outlet />
      <div className="area-page-sidebar flex flex-col gap-y-24">
        <CustomerInformation customer={data} />
      </div>
    </div>
  );
}
